import { Mixpanel } from 'mixpanel-react-native'

import { ENVIRONMENT, MIXPANEL_TOKEN } from '../constants/config'

const mixpanelInstance = new Mixpanel(MIXPANEL_TOKEN || 'test-token', false)

export const mixPanelTrackEvent = (eventName: string, properties?: Record<string, string | number>) => {
  if (ENVIRONMENT !== 'prod') {
    return
  }
  mixpanelInstance.track(eventName, properties ?? {})
}

export const mixPanelIdentify = async (email: string) => {
  if (ENVIRONMENT !== 'prod') {
    return
  }
  await mixpanelInstance.identify(email)
}

export const mixPanelReset = () => {
  if (ENVIRONMENT !== 'prod') {
    return
  }
  mixpanelInstance.reset()
}

export default mixpanelInstance
